import { useEffect, useState } from 'react';
import axios from 'axios';
import ShortNews from '../../molecules/ShortNews';
import Loader from '../common/Loader';
import Text from '../../atoms/Text';

interface IProps {
  slug: string;
}

/**
 * Temporary solution, probably will be extracted into token api
 * @param slug
 */
const fetchNews = async (slug: string): Promise<INewsItem[]> => {
  try {
    const { data } = await axios.get(
      `https://api-staging.kattana.trade/coins/${slug}/news`
    );
    const { news } = data;
    return news;
  } catch (err) {
    console.error('fetchNews:' + err);
    return [];
  }
};

interface INewsItem {
  CreatedAt: string;
  Hash: string;
  ID: number;
  Link: string;
  Processed: boolean;
  SourceID: number;
  Text: string;
  Title: string;
  Verified: boolean;
}

/**
 * Temporary solution to fetch news according to the mapping
 */
const useCoinNews = (slug: string) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [news, setNews] = useState<INewsItem[]>([]);

  useEffect(() => {
    let mounted = true;
    if (slug) {
      setLoading(true);
      fetchNews(slug)
        .then((news: any) => {
          if (mounted) {
            setNews(news);
            setLoading(false);
          }
        })
        .catch(() => {
          if (mounted) {
            setNews([]);
            setLoading(false);
          }
        });
    } else {
      if (mounted) {
        setNews([]);
        setLoading(false);
      }
    }

    return () => {
      mounted = false;
    };
  }, [slug]);

  return {
    loading,
    news,
  };
};

const CoinNews = (props: IProps) => {
  const { slug } = props;
  const { news, loading } = useCoinNews(slug);
  if (!slug) {
    return (
      <div className='miniNews'>
        <Text size={14} className='text--grey-400 text--nowrap'>
          Not available
        </Text>
      </div>
    );
  }
  if (loading) {
    return <Loader />;
  }
  return <ShortNews news={news} />;
};

export default CoinNews;
